import styled from 'styled-components';
import {
  companyColor,
  defaultColor,
  font,
  fluidFont,
  spacing,
  device,
} from 'styles/theme';

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('default')};
  margin-top: ${spacing('large')};
`;

export const SectionTitle = styled.div`
  font-family: ${font('semibold')};
  ${fluidFont('18px', '20px')};
  color: ${companyColor('font')};
`;

export const Table = styled.div`
  width: 100%;
  overflow-x: auto;

  @media only screen and (${device('laptop')}) {
    overflow: unset;
  }
`;

export const Cell = styled.td`
  text-align: ${({ $align }) => $align || 'right'};
  vertical-align: top;

  &:first-child {
    text-align: ${({ $align }) => $align || 'left'};
  }

  padding: 15px 20px;
  border-bottom: 1px solid ${defaultColor('background')};
  color: ${({ isBold }) => (isBold ? companyColor('font') : defaultColor('font'))};
  font-family: ${({ isBold }) => (
    isBold ? font('semibold') : font('regular')
  )};
  ${fluidFont('11px', '13px')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media only screen and (${device('tablet')}) {
    padding: 0.875rem 1rem;
  }

  @media only screen and (${device('mobileSmall')}) {
    padding: 0.75rem 0.875rem;
  }
`;

export const Tags = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Ellipsis = styled.span`
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StatusWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
`;

export const Amount = styled.span`
  text-decoration: ${({ $refunded }) => ($refunded ? 'line-through' : 'none')};
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Empty = styled.span`
  ${fluidFont('12px', '18px')};
  color: ${companyColor('font')};
`;
